import React from 'react';
import { getEnvironment } from '../utils/environment';
import { FONT_FAMILY } from '../constants/font';

/**
 * EnvBanner — Banner visual que indica en que ambiente esta corriendo la UI.
 *
 * Se detecta por hostname (ver utils/environment.js). En production se
 * esconde (return null). En staging/development muestra una franja fija top.
 *
 * Proposito: evitar que el equipo haga cambios en staging pensando que es prod
 * (o viceversa). El banner es imposible de ignorar — franja naranja/azul en el
 * top de cada pagina.
 */
export default function EnvBanner() {
  const env = getEnvironment();

  if (env === 'production') return null;

  const isStaging = env === 'staging';

  const label = isStaging ? 'STAGING — ambiente de pruebas' : 'DEVELOPMENT — ambiente local';
  const bg = isStaging ? '#F59E0B' : '#3B82F6';

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      height: 28,
      background: bg,
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 12,
      fontWeight: 700,
      letterSpacing: '0.5px',
      zIndex: 9999,
      fontFamily: FONT_FAMILY,
      textTransform: 'uppercase',
      boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
    }}>
      <span style={{ marginRight: 8 }}>
        {isStaging ? '🧪' : '🔧'}
      </span>
      {label}
      {isStaging && (
        <span style={{ marginLeft: 16, fontSize: 11, opacity: 0.9, fontWeight: 500 }}>
          · los cambios aqui NO afectan a producción
        </span>
      )}
    </div>
  );
}
